/**
 * 深拷贝
 */
function deepCopy (target) {
    let result;
    if (typeof target === "object") {
        if (Array.isArray(target)) {
            result = [];
            for (let i in target) {
                result.push(deepCopy(target[i]));
            }
        } else if (target === null) {
            result = target;
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            result = {};
            for (let i in target) {
                result[i] = deepCopy(target[i]);
            }
        }
    } else {
        result = target;
    }
    return result;
}

/**
 * className 对象转字符串
 */
export function buildClass (target) {
    const arr = []
    Object.keys(target).forEach(k => {
        return target[k] && arr.push(k);
    });
    return arr.join(" ");
}
